import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  zipDownloadChannel: null,
  zipStatus: null,
  zipUrl: null,
  zipDismissed: false,
};

export const filePlayerSlice = createSlice({
  name: 'filePlayer',
  initialState,
  reducers: {
    setZipDownloadChannel: (state, action) => {
      state.zipDownloadChannel = action.payload;
    },
    setZipStatus: (state, action) => {
      const payload = action.payload || {};

      ['zipStatus', 'zipUrl', 'zipDismissed'].forEach((key) => {
        if (payload.hasOwnProperty(key)) {
          state[key] = payload[key];
        }
      });
    },
    clearZipState: (state) => {
      state.zipDownloadChannel = null;
      state.zipStatus = null;
      state.zipUrl = null;
      state.zipDismissed = false;
    },
  },
});

export const {
  setZipDownloadChannel,
  setZipStatus,
  clearZipState,
} = filePlayerSlice.actions;
